import { useQuery } from '@tanstack/react-query'

import { getTransactionEvidenceEmails } from '@src/api'
import { DefaultApiGetTransactionEvidenceEmailsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchTransactionEvidenceEmails = (
  params: DefaultApiGetTransactionEvidenceEmailsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled:
      !!params.userAccountId &&
      !!params.startYearMonth &&
      !!params.endYearMonth,
    queryFn: () => getTransactionEvidenceEmails(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_TRANSACTION_EVIDENCE_EMAILS, params],
  })
}
